import React from 'react';
import PropTypes from 'prop-types';
import { Popconfirm, Select, Input, Button } from 'antd';

import { IconDelete } from '../../../data/assets/icons';

const Option = Select.Option;

class SelectArrayItem extends React.PureComponent {
    state = {
        selected_array_item: null,
    };

    onChangeArrayItem = (value, option) => {
        if (option && option.props && option.props.selected_option) {
            this.setState({
                selected_array_item: option.props.selected_option,
            })
        }
    };

    onChangeInputItem = e => {
        this.setState({
            selected_array_item: e.target.value,
        })
    };

    onClickArrayItemAdd = () => {
        const { selected_array_item } = this.state;
        const { onClickAdd } = this.props;
        if (selected_array_item) {
            onClickAdd(selected_array_item);
            this.setState({ selected_array_item: null });
        }
    };

    filterOption = (input, option) => (option.props.children && option.props.children.toLocaleString().toLowerCase().indexOf(input.toLowerCase()) >= 0);

    render() {
        const { selected_array_item } = this.state;
        const { type, input_type, container_class, title, title_class, array, value_card_container_class, value_container_class, delete_container_class, options, select_placeholder, popconfirm_placement, popconfirm_title, popconfirm_ok_text, popconfirm_cancel_text, popconfirm_overlay_class, select_dropdown_class, show_search, onClickDelete, add_btn_class, add_btn_text } = this.props;
        const is_string_type = type === 'string';
        const is_object_type = type === 'object';

        return (
            <div className={container_class}>
                {
                    title &&
                    <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
                }
                {
                    array && array.map((item, index) => {
                        return (
                            <div key={index} className={`ori-relative ${value_card_container_class}`}>
                                <div className={"ori-full-width ori-r-pad-25"}>
                                    <div className={value_container_class}>
                                        {
                                            is_object_type &&
                                            <span>{item.value}</span>
                                        }
                                        {
                                            is_string_type &&
                                            <span>{item}</span>
                                        }
                                    </div>
                                </div>
                                <div className={`ori-absolute ${delete_container_class}`}>
                                    <Popconfirm overlayClassName={popconfirm_overlay_class} placement={popconfirm_placement} title={popconfirm_title} okText={popconfirm_ok_text} cancelText={popconfirm_cancel_text} onConfirm={onClickDelete.bind(this, index)}>
                                        <div className="ori-pad-3">
                                            <IconDelete size={17} className="ori-font-light-hover-primary ori-cursor-ptr" />
                                        </div>
                                    </Popconfirm>
                                </div>
                            </div>
                        );
                    })
                }
                {
                    input_type === 'select' &&
                    <div className="ori-full-width ori-tb-pad-5">
                        <Select className="ori-full-width" dropdownClassName={select_dropdown_class} placeholder={select_placeholder} showSearch={show_search} optionFilterProp="children" filterOption={this.filterOption} value={selected_array_item ? (is_object_type ? selected_array_item.value : (is_string_type ? selected_array_item : undefined)) : undefined} onChange={this.onChangeArrayItem}>
                            {
                                is_object_type && options.map(option => {
                                    return (
                                        <Option key={option.id} selected_option={option} value={option.id}>{option.value}</Option>
                                    );
                                })
                            }
                            {
                                is_string_type && options.map((option, index) => {
                                    return (
                                        <Option key={index} selected_option={option} value={option}>{option}</Option>
                                    );
                                })
                            }
                        </Select>
                    </div>
                }
                {
                    input_type === 'input' &&
                    <Input className="ori-b-mrgn-10 ori-font-xs" placeholder={select_placeholder} value={selected_array_item} onChange={this.onChangeInputItem} onPressEnter={this.onClickArrayItemAdd} />
                }
                <Button type='primary' className={add_btn_class} disabled={selected_array_item ? false : true} onClick={this.onClickArrayItemAdd}>{add_btn_text}</Button>
            </div>
        );
    }
}

SelectArrayItem.propTypes = {
    type: PropTypes.oneOf(['string', 'object']).isRequired,
    input_type: PropTypes.oneOf(['input', 'select']),
    container_class: PropTypes.string,
    title: PropTypes.string,
    title_class: PropTypes.string,
    array: PropTypes.array.isRequired,
    value_card_container_class: PropTypes.string,
    value_container_class: PropTypes.string,
    delete_container_class: PropTypes.string,
    options: PropTypes.array,
    select_placeholder: PropTypes.string,
    popconfirm_placement: PropTypes.string,
    popconfirm_title: PropTypes.string,
    popconfirm_ok_text: PropTypes.string,
    popconfirm_cancel_text: PropTypes.string,
    popconfirm_overlay_class: PropTypes.string,
    show_search: PropTypes.bool,
    select_dropdown_class: PropTypes.string,
    onClickDelete: PropTypes.func,
    onClickAdd: PropTypes.func,
    notification_position: PropTypes.string,
    add_btn_class: PropTypes.string,
    add_btn_text: PropTypes.string,
};

SelectArrayItem.defaultProps = {
    type: "object",
    input_type: "select",
    container_class: "ori-tb-pad-5",
    array: [],
    options: [],
    value_card_container_class: "ori-tb-mrgn-5 ori-bg-default ori-border-default ori-border-radius-4",
    value_container_class: "ori-lr-pad-10 ori-tb-pad-5 ori-font-13",
    delete_container_class: "ori-align-top ori-align-right-3",
    popconfirm_placement: "top",
    popconfirm_title: "Are you sure？",
    popconfirm_ok_text: "Yes",
    popconfirm_cancel_text: "No",
    popconfirm_overlay_class: "",
    select_dropdown_class: "",
    show_search: true,
    add_btn_class: "ori-full-width ori-capitalize",
    add_btn_text: "add array item",
};

export default SelectArrayItem;


// WEBPACK FOOTER //
// ./src/components/form/selectarrayitem/index.js